import React from "react";
import { Link } from "react-router-dom";
import { Home } from "lucide-react";
import { useLang } from "../context/LangContext";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer className="bg-[#0E1B14] text-slate-300 mt-24">
      <div className="max-w-7xl mx-auto px-5 md:px-10 py-16 grid grid-cols-2 md:grid-cols-5 gap-10">
        <div className="col-span-2">
          <div className="flex items-center gap-2 mb-4">
            <div className="w-9 h-9 rounded-xl bg-[#1B8F5A] flex items-center justify-center"><Home size={17} className="text-white" strokeWidth={2.5} /></div>
            <span className="text-xl font-bold text-white">Naydars</span>
          </div>
          <p className="text-sm max-w-sm leading-relaxed text-slate-400">{t("footerAbout")}</p>
        </div>

        <div>
          <h4 className="text-white text-sm font-bold mb-4">Naydars</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/about" className="hover:text-white">{t("about")}</Link></li>
            <li><Link to="/careers" className="hover:text-white">{t("careers")}</Link></li>
            <li><Link to="/press" className="hover:text-white">{t("press")}</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-white text-sm font-bold mb-4">{t("support")}</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/help" className="hover:text-white">{t("helpCenter")}</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-white text-sm font-bold mb-4">Legal</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/privacy" className="hover:text-white">{t("privacyPolicy")}</Link></li>
            <li><Link to="/terms" className="hover:text-white">{t("termsConditions")}</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-6 text-center text-xs text-slate-500">© {new Date().getFullYear()} Naydars. {t("footerLegal")}.</div>
    </footer>
  );
}
